<template>
  <v-btn icon density="compact" v-on:click="toggle_weekends" color="green" class="mr-2">
    <v-icon :class="{'selected-weekend' : hidden_weekends}" :icon="['fas', '5']" />
    <v-icon :icon="['fas', 'slash']" style="rotate: 70deg; margin-left: -5px; margin-right: -5px; transition: 1s" :class="{ 'reverse': hidden_weekends }" />
    <v-icon :class="{'selected-weekend' : !hidden_weekends}" :icon="['fas', '7']" />

    <v-tooltip activator="parent" location="bottom">
      Отображение недели
    </v-tooltip>
  </v-btn>
</template>

<script>

import { HideWeekends } from "@/store/wp_planner/settings.store";

export default {
  name: "ToggleWeekends__WP_Widget",
  data() {
    return {

    }
  },
  methods: {
    toggle_weekends: function () {
      this.hidden_weekends = !this.hidden_weekends
    },
  },
  computed: {
    hidden_weekends: {
      get() {
        return HideWeekends().get()
      },
      set(v) {
        HideWeekends().set(v)
      }
    }
  }
}
</script>

<style scoped>
.selected-weekend {
  color: #0d7115;
}


.toggle-button {
  cursor: pointer;
  writing-mode: vertical-lr;
  text-align: center;
  transition: 0.3s;
  opacity: 1;
}

.reverse {
  rotate: 220deg !important;
}


</style>
